import { useGetReceptionVolumeByDateQuery } from "@/redux/services/recordApi";
import { Alert, Card, Flex, Spin } from "antd";
import ReactEcharts from "echarts-for-react";

export function TravelPeopleDayLine({ selectedDateByDay }) {
	const { data, isError, isLoading } =
		useGetReceptionVolumeByDateQuery(selectedDateByDay);

	let xAxisData = [];
	let seriesData = [];

	if (data) {
		Object.entries(data).forEach(([key, value]) => {
			xAxisData.push(key);
			seriesData.push(value);
		});
	}

	const getOption = () => {
		let option = {
			xAxis: {
				type: "category",
				boundaryGap: false,
				data: xAxisData,
			},
			yAxis: {
				type: "value",
				name: "人数",
				nameLocation: "end",
				nameTextStyle: {
					fontSize: 14,
					padding: [0, 0, 10, 0], // 上右下左
				},
			},
			series: [
				{
					data: seriesData,
					type: "line",
					areaStyle: {},
					smooth: true,
					label: {
						show: true,
						position: "top",
					},
					emphasis: {
						focus: "series",
					},
					itemStyle: {
						color: "#FFCE34",
					},
				},
			],
			tooltip: {
				trigger: "axis",
				axisPointer: {
					type: "cross",
					label: {
						backgroundColor: "#6a7985",
					},
				},
			},
		};
		return option;
	};

	return (
		<Card
			style={{
				border: "1px solid #FFCE34",
			}}
			title="旅行人数"
			styles={{
				header: {
					backgroundColor: `#FFCE34`,
				},
			}}
		>
			{isError && (
				<Alert
					message="Error"
					description="Something went wrong ..."
					type="error"
					showIcon
				/>
			)}

			{isLoading && (
				<Flex
					justifyContent="center"
					alignItems="center"
					style={{ width: "100%", height: "50vh" }}
				>
					<Spin size="large" />
				</Flex>
			)}

			{!isError && data != null && (
				<div
					style={{ width: "100%", margin: "0 auto", height: "350px" }}
				>
					<ReactEcharts
						option={getOption()}
						style={{ width: "100%", height: "100%" }}
					/>
				</div>
			)}
		</Card>
	);
}
